define([
	"dojo/_base/declare",
	"csi/action/AggregateBaseController",
	"csi/xml"
], function(declare,AggregateBaseController,xml) {

return declare(AggregateBaseController,
	{
		toWriterRequest: function(){
			// get the URL of ExportBatch pass to us in Export.onToolbarDropdownInstantiating
			// and use it as a current node
			var oldNodeURL = this.m_urlNode;
			this.m_urlNode = this.m_action.urlBatch;

			var call = this.inherited(arguments);
			if (this.m_action.exportPath) {
				call.addParameter("Path", xml.ATTR_STRING, this.m_action.exportPath);
			}

			this.m_urlNode = oldNodeURL;

			return call;
		}
	}
);
});